<div id="global-links-bar" class="text-right" data-qa="global-links-bar" role="navigation" aria-label="utility">
  <div class="container">
    <ul class="list-inline">
      <li *ngIf="feedbackSSOId">
          <a href="javascript:void(0);" (click)="OpenSurveyWindow()" >Feedback</a>
      </li>
      <li *ngFor="let link of globalLinks">
        <a href="{{link.url}}">{{link.title}}</a>
      </li>
    </ul>
  </div>
</div>
